import clsx from "clsx";
import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";

interface CustomHTMLProps extends React.HTMLProps<HTMLInputElement> {
  addon: React.ReactNode;
  containerClassName?: string;
  onEnterKeyPress?: (query: string) => void;
}
type MergedProps = React.HTMLProps<HTMLElement> & CustomHTMLProps;
const InputWithAddOn: React.FC<MergedProps> = ({ addon, containerClassName, onEnterKeyPress, ...props }) => {
  const [query, setQuery] = useState("");

  const handleClear = () => {
    setQuery(""); // Clear the input field
    if (onEnterKeyPress) {
      onEnterKeyPress(""); // Fetch all data when cleared
    }
  };

  return (
    <div className={clsx(containerClassName)}>
      <div className="flex shadow-sm mt-2 rounded-md relative">
        <span className="inline-flex items-center border-gray-300 px-3 border border-r-0 rounded-l-md text-gray-500 sm:text-sm">
          {addon}
        </span>
        <input
          {...props}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e: any) => {
            if (e.code === "Enter") {
              e.preventDefault();
              if (onEnterKeyPress) {
                onEnterKeyPress(query);
              }
            }
          }}
          className="block flex-1 border-0 py-1.5 rounded-none rounded-r-md ring-1 ring-gray-300 focus:ring-2 focus:ring-indigo-600 ring-inset focus:ring-inset w-full min-w-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 pr-10"
        />
        {query && (
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            onClick={handleClear}
          >
            <FaTimes className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default InputWithAddOn;
